var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-price.j2"] = require( "macros/product-price.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/core-product-tile-price.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/product-price.j2", false, "core/templates/core-product-tile-price.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayPricing")) {
var t_4 = t_1.displayPricing;
} else {
cb(new Error("cannot import 'displayPricing'")); return;
}
context.setVariable("displayPricing", t_4);
if(t_1.hasOwnProperty("displayPriceValue")) {
var t_5 = t_1.displayPriceValue;
} else {
cb(new Error("cannot import 'displayPriceValue'")); return;
}
context.setVariable("displayPriceValue", t_5);
if(runtime.contextOrFrameLookup(context, frame, "wishlist")) {
var t_6;
t_6 = false;
frame.set("showRange", t_6, true);
if(frame.topLevel) {
context.setVariable("showRange", t_6);
}
if(frame.topLevel) {
context.addExport("showRange", t_6);
}
output += "\n\n";
;
}
else {
output += "\n\n    ";
var t_7;
t_7 = true;
frame.set("showRange", t_7, true);
if(frame.topLevel) {
context.setVariable("showRange", t_7);
}
if(frame.topLevel) {
context.addExport("showRange", t_7);
}
output += "\n\n";
;
}
if(runtime.contextOrFrameLookup(context, frame, "displayPrice") && runtime.contextOrFrameLookup(context, frame, "tile") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"skuInfo") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"skuInfo")),"hasAvailableSku") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"product") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"product")),"visualBadge") != "displaySoldOut") {
output += "<p class=\"c-product-tile__price c-product-tile__price--";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "tileTemplate"), env.opts.autoescape);
output += "\">\n        <span itemprop=\"offers\" itemscope itemtype=\"//schema.org/AggregateOffer\">\n            <meta itemprop=\"offerCount\" content=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"totalAvailableSkuCount"), env.opts.autoescape);
output += "\" />\n            <meta itemprop=\"lowPrice\" content=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"skuInfo")),"listPriceLow"), env.opts.autoescape);
output += "\" />\n            <meta itemprop=\"highPrice\" content=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"skuInfo")),"listPriceHigh"), env.opts.autoescape);
output += "\" />\n            <meta itemprop=\"priceCurrency\" content=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"currency"), env.opts.autoescape);
output += "\" />";
if(runtime.contextOrFrameLookup(context, frame, "wishlist")) {
output += runtime.suppressValue((lineno = 21, colno = 34, runtime.callWrap(t_5, "displayPriceValue", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"skuInfo")),"primarySlice")),"sliceItems")),0)),"includedSkus")),0)),"salePrice"),runtime.contextOrFrameLookup(context, frame, "core"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "wishlist")),"transactionalCurrencyFormattingInformation")])), env.opts.autoescape);
;
}
else {
output += runtime.suppressValue((lineno = 23, colno = 31, runtime.callWrap(t_4, "displayPricing", context, [runtime.contextOrFrameLookup(context, frame, "tile"),runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "showRange")])), env.opts.autoescape);
;
}
output += "</span>\n    </p>";
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/core-product-tile-price.j2"] , dependencies)